<div class="flex flex-1 flex-col overflow-hidden">
  <div class="flex flex-0 items-center justify-between bg-slate-50 px-4 py-2">
    <span class="text-sm font-semibold uppercase text-primary">Community Location</span>
    <mat-form-field class="fuse-mat-dense w-64">
      <input matInput placeholder="Search Community" [formControl]="searchControl" [matAutocomplete]="auto" (input)="onSearchInput($event)" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onAssociationSelected($event.option.value)">
        @for (association of filteredAssociations; track association.id) {
          <mat-option [value]="association">{{ association.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="min-h-0 flex-1">
    <google-map [center]="center" [zoom]="zoom" [options]="mapOptions" width="100%" height="100%">
      @for (marker of markers; track marker.id) {
        <map-advanced-marker [position]="getMarkerPosition(marker)" [content]="marker.content" (mapClick)="selectedMarker(marker.id)"></map-advanced-marker>
      }
      <map-info-window>
        @if (hoverMarker) {
          <fuse-card class="flex-col overflow-hidden">
            <div class="bg-primary px-3 py-2 text-sm font-bold uppercase text-white">{{ hoverMarker.name }}</div>
            <div class="space-y-1 p-3 text-sm font-bold">
              <div><span class="text-primary">No of Units :</span> {{ hoverMarker.units }}</div>
              <div><span class="text-primary">Type :</span> {{ hoverMarker.type }}</div>
            </div>
          </fuse-card>
        }
      </map-info-window>
    </google-map>
  </div>
</div>
